export default __webpack_public_path__ + "assets/images/1d016bd6a09f9713f43f805e65042732.png";